module.exports = __webpack_public_path__ + "img/donut.cc39e67f.svg";